import { Check, Tag, User } from 'lucide-react'
import { assigneeNames } from '../../lib/useHuddleStaff.js'

/**
 * The morning-huddle upsell plan for one appointment, as chips.
 *
 * Used on the huddle queue, the appointments day table, and the printed A4 day
 * sheet, so a plan made at 08:30 is in front of whoever greets the patient.
 * A chip ticks green when that exact promotion was actually assigned to the
 * patient that day (derived from promotion_patient — see planOutcome).
 *
 * The pitch `note` is deliberately NOT rendered here: this component appears on
 * paper, and the printed sheet lives on the counter where a patient can read it.
 * Names only.
 *
 * `assignees` (employee ids) renders after the promotions as who owns the pitch.
 * Staff names are fine on the counter sheet — the patient reading it will be
 * talking to that person anyway.
 */
export default function PlanChips({ ids = [], hits, promoNames, assignees = [], staffNames, label = true, className = '' }) {
  const who = assigneeNames(assignees, staffNames)
  if (!ids.length && !who.length) return null
  const has = (id) => !!hits?.has?.(Number(id))
  return (
    <div className={`flex flex-wrap items-center gap-1 ${className}`}>
      {label && (
        <span className="inline-flex items-center gap-1 text-[11px] text-slate-400 mr-0.5">
          <Tag size={11} /> แผนอัปเซล
        </span>
      )}
      {ids.map((id) => {
        const won = has(id)
        return (
          <span
            key={id}
            title={won ? 'ขายได้แล้ววันนี้' : 'วางแผนไว้ ยังไม่ได้ขาย'}
            className={`inline-flex items-center gap-1 rounded px-1.5 py-0.5 text-[11px] ring-1 whitespace-nowrap max-w-[220px] truncate ${
              won ? 'bg-emerald-50 text-emerald-700 ring-emerald-200' : 'bg-brand-50 text-brand-700 ring-brand-200'}`}
          >
            {won && <Check size={10} strokeWidth={3} className="flex-none" />}
            {promoNames?.get?.(Number(id)) || `#${id}`}
          </span>
        )
      })}
      {who.map((name, i) => (
        <span
          key={`w${i}`}
          title="ผู้รับผิดชอบ"
          className="inline-flex items-center gap-0.5 rounded px-1.5 py-0.5 text-[11px] ring-1 whitespace-nowrap max-w-[220px] truncate bg-slate-50 text-slate-600 ring-slate-200"
        >
          <User size={10} strokeWidth={2.5} className="flex-none" />{name}
        </span>
      ))}
    </div>
  )
}
